import { apiSlice } from "@/shared/api/api-slice"
import type { DeleteBusinessMessagesResponse } from "@/shared/types/api/business-mode.types"

export const deleteBusinessMessagesApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    deleteBusinessMessages: builder.mutation<DeleteBusinessMessagesResponse, void>({
      query: () => ({
        url: "/api/v1/business/connections/messages",
        method: "DELETE"
      })
    })
  })
})

export const { useDeleteBusinessMessagesMutation } = deleteBusinessMessagesApi
